/**
 * @module interface
 */
export interface V2TimUserInfo {
    userID: string;
    nickName?: string;
    faceUrl?: string;
}
